import { consumeOAuthIntent, OAUTH_INTENT_MAX_AGE_MS } from '@/utils/oauthIntent';

// The home request form is saved here when the visitor leaves it for a login, a signup or Google, so it can be restored.
// Restoring is all a stored form is for. It is sent without a tap only when the visitor acted on it a moment ago.
export const REQUEST_FORM_STORAGE_KEY = 'ofair_request_form_data';

export const clearStoredRequestForm = (): void => {
  try {
    localStorage.removeItem(REQUEST_FORM_STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing stored request form:', error);
  }
};

// Read by the pages that hand a stored form back to the home page after phone verification (Login, PhoneRequiredDialog),
// to decide whether it goes out by itself (router state submitPendingRequest). True only if the same-tab marker left by the
// login, signup or Google click in the form is fresh AND the stored form is under 10 minutes old. The marker is deleted by
// the read, so a form left behind by an abandoned attempt never goes out on a later, unrelated verification.
export const consumeStoredFormSendIntent = (): boolean => {
  const marked = consumeOAuthIntent('form');
  if (!marked) return false;
  try {
    const raw = localStorage.getItem(REQUEST_FORM_STORAGE_KEY);
    if (!raw) return false;
    const { timestamp } = JSON.parse(raw) as { timestamp?: number };
    return typeof timestamp === 'number' && Date.now() - timestamp < OAUTH_INTENT_MAX_AGE_MS;
  } catch {
    return false;
  }
};
